import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { AppContextProvider } from '../AppLoader';
import { EmailCodeDialog } from '../EmailCodeDialog/EmailCodeDialog';
import {
  PoliciesContainer,
  PoliciesVerticalContainer,
} from '../PoliciesContainer';
import { keys } from '../../translationsKeys';
import { Recaptcha } from '../Recaptcha/Recaptcha';

/** The code step of an email-code login. */
const LoginEmailCodeDialog: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: {
      loginEmailFactorStore,
      loginStore,
      displayStore: { isVerticalLayout, policiesOutsideCard },
    },
  } = useContext(AppContextProvider);
  // A CAPTCHA a code send asked for, drawn once this screen holds its widget.
  useEffect(() => {
    loginStore.pendingCaptcha.render();
  }, [loginStore, loginStore.pendingCaptcha.errorCode]);
  // The policies sit where the login form puts them (LoginWrapper).
  const inCard = isVerticalLayout && !policiesOutsideCard;

  return (
    <EmailCodeDialog
      store={loginEmailFactorStore}
      pageName="login-react-app.login-email-code"
      dataHookPrefix="login.emailCode"
      submitLabel={t(keys['login.submit'])}
      passwordLabel={t('login.email_code.use_password', {
        defaultValue: 'Use Your Password',
      })}
      // The modal header's back changes the email too, as the main header's
      // does: it drops the code.
      shouldGoBackToEmailInModal
      captcha={<Recaptcha />}
      belowCard={
        inCard ? null : isVerticalLayout ? (
          <PoliciesContainer.Expanded />
        ) : (
          <PoliciesContainer.Minimal />
        )
      }
    >
      {inCard && (
        <PoliciesVerticalContainer>
          <PoliciesContainer.Minimal />
        </PoliciesVerticalContainer>
      )}
    </EmailCodeDialog>
  );
});

export default LoginEmailCodeDialog;
